import { getMenuAuth } from "src/apis/authApi";
import {  useCallback, useEffect } from "react";
import {  getKSK1090_R01List, getKSK1090_R01AllCount, exportKSK1090_R01Excel } from "./Api_KSK1090_R01"
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import useMenuGlobalStore from "src/store/useMenuStore";
import { downloadSettingExcel } from "src/utils/blob/blobUtil";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";

import { useKSK1090_R01Store, defaultKSK1090_R01Filter, KSK1090_R01Filter } from "./Store_KSK1090_R01";
import { KSK1090_R01Dto } from "./Dto_KSK1090_R01";
import { fetchDataSetHandler, fetchFilterConfig } from "src/utils/grid/GridHandlerContent";

interface ProductResultContentProps {
    setMessage: (message: string) => void;
}

export const Content_KSK1090_R01 = (props: ProductResultContentProps) => {
    const { setMessage } = props;

    const { 
        KSK1090_R01Filter, setKSK1090_R01Filter,
        KSK1090_R01PastFilter, setKSK1090_R01PastFilter,
        KSK1090_R01List, setKSK1090_R01List, 
        setAllCount,
    } = useKSK1090_R01Store();
    const { setLoadingSpinner } = useLoadingSpinnerStore();
    // const { selectedThirdMenu } = useMenuGlobalStore();
    // const menuCdStore = selectedThirdMenu?.menuCd;
    const setAuth = useActionbarAuthStore((state) => state.setAuth);

    useFetchActionbarAuth("KSK1090_R01");

    useEffect(() => {
        getMenuAuth("KSK1090_R01").then((res) => {
            setAuth(res.data);
        });
    }, []);

    // useEffect(() => {
    //     if (!menuCdStore) {
    //         console.log("[KSK1090_R01] menuCd가 없습니다. 메뉴를 선택하세요.");
    //     } else {
    //         console.log("[KSK1090_R01] menuCd:" + menuCdStore);
    //     }
    // }, [menuCdStore]);

    const getParams = (filter: Partial<KSK1090_R01Filter>) => {
        return {
            compCd: filter.compCd,
            transportDt: filter.transportDt,
            logicCenter: filter.logicCenter,
            workplaceCd: filter.workplaceCd,
            itemCd: filter.itemCd,
            brandCd: filter.brandCd,
            customCd: filter.customCd,
            itemGroup: filter.itemGroup,
            inoutClass: filter.inoutClass,
        };
    }

    const renewalAllCount = useCallback(async () => {
        const response = await getKSK1090_R01AllCount(getParams(KSK1090_R01Filter));
        setAllCount(response.data.data);
        return response.data.data;
    }, [KSK1090_R01Filter, setAllCount]);

    const fetchData = useCallback(async () => {
        setLoadingSpinner(true);
        try {
			
            const response = await getKSK1090_R01List(
                '',
                getParams(KSK1090_R01Filter),
                KSK1090_R01List.length ?? 0
            );

            const rawData = (response.data.data as Omit<KSK1090_R01Dto, 'valueIndex'|'orderIndex'|'orderIndexSeq'>[]).map((row, idx) => ({
                valueIndex: idx,
                orderIndex: idx + 1,
                orderIndexSeq: 0,
                ...row,
            }));

			const newList = [...rawData ] as KSK1090_R01Dto[];
            const processAllCount = await renewalAllCount();

            if (newList && newList.length > 0) {
                setKSK1090_R01PastFilter(KSK1090_R01Filter);
                setKSK1090_R01List(newList);
                ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
            } else {
                showWarning('데이터가 없습니다.');
                setKSK1090_R01List([]);
            }
        } catch (error) {
            console.error('데이터 조회 실패:', error);
            showWarning('데이터 조회에 실패했습니다.');
            setKSK1090_R01List([]);
        } finally {
            setLoadingSpinner(false);
        }
    }, [KSK1090_R01Filter, setKSK1090_R01List, setKSK1090_R01PastFilter]);
    
    const handleExcelClick = async () => {
        const {isDefaultFilter, isDefaultPastFilter, listLength} = fetchFilterConfig(
            KSK1090_R01Filter,
            KSK1090_R01PastFilter,
            defaultKSK1090_R01Filter,
            KSK1090_R01List.length
        );

        const response = await exportKSK1090_R01Excel(
            isDefaultFilter? '' : 'search',
            getParams(KSK1090_R01Filter),
            listLength
        );
        downloadSettingExcel({
            responseData: response.data.data,
            fileName: '입고현황 조회-excel.xlsx',
        });
    };

    return {
        fetchData,
        handleExcelClick,
    };
};


